import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from "react-router-dom";
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import './css/CustomerAccount.scss'


import CustomerAccountMobile from '../customeraccount/CustomerAccountMobile';
import CustomerAccountDesktop from '../customeraccount/CustomerAccountDesktop';
import Transition from './../../transition';
import variables from "../../global/assets/_variables.scss";
import AtomicButton from '../../atomic/button/AtomicButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { PersonOutlineOutlined } from "@mui/icons-material";



const CustomerAccount = () => {
    const { isLoggedIn, onLogout } = useContext(LoginDataContext);
    const navigate = useNavigate();
    const triggerLogout = async () => {
        await onLogout()
        navigate('/onthemenu')
        window.location.reload()
    }

    return (
        <>
            {(isDesktop || isIpad) && <CustomerAccountDesktop />}
            {isMobile && <CustomerAccountMobile />}

            {isMobile && <AtomicButton
                label="Logout"
                style={{
                    width: '100px',
                    backgroundColor: `${variables.backgroundButtonBlack}`,
                    fontSize: '12px',
                    height: '35px',
                    marginLeft: '16%'
                }}
                handleSubmit={() => triggerLogout()}
                endIcon={''}
                startIcon={<LogoutIcon sx={{ width: '20px' }} />} />}

        </>
    )
}

export default Transition(CustomerAccount)